<template>
  <div :class="`small-box ${background}`">
    <div class="inner">
      <h3>{{ counter }}</h3>

      <p>{{ title }}</p>
    </div>
    <div class="icon">
      <i :class="`fas ${icon}`"></i>
    </div>
    <!--<a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a>-->
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: "StatisticCounter",
    props: {
      counter: String,
      background: {
        type: String,
        default: "bg-warning",
      },
      title: {
        type: String,
        default: "-",
      },
      icon: {
        type: String,
        default: "fa-plus"
      }
    },
  }
</script>

<style scoped>

</style>
